/**
 * Helpers shared by the stored travel ball signups (program and family, in
 * `tbProgramSignupStorage.ts` and `tbFamilySignupStorage.ts`).
 */

/**
 * How long a stored travel ball signup (program or family) can be resumed. Every route sends a
 * profile-less account with a stored signup back to it, and an already-verified address finishes on
 * its own, so an abandoned signup must not live forever: past this it is discarded, and the person is
 * treated like anyone else with no signup under way. A blob with no `savedAt` (from a build before
 * this) is discarded too.
 */
export const TRAVEL_BALL_SIGNUP_MAX_AGE_MS = 24 * 60 * 60 * 1000;

/** Whether a stored `savedAt` (milliseconds) is recent enough to resume. */
export const isFreshTravelBallSignup = (savedAt: unknown): boolean =>
  typeof savedAt === 'number' &&
  Number.isFinite(savedAt) &&
  Date.now() - savedAt <= TRAVEL_BALL_SIGNUP_MAX_AGE_MS;
